import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form, Button, FormControl, Table } from "react-bootstrap";
import { LuFiles, LuPencilLine, LuDiameter, LuPlus, LuSquareArrowOutUpRight, LuCircleArrowOutUpRight, LuZap, LuCircleCheckBig } from "react-icons/lu";
import { Link, useParams } from "react-router-dom";
import API from "../../../services/axiosInstance"
import Pagination from "../../common_modules/pagination";
import FilterBar from "../../common_modules/filter";
import { makePageableData } from "../../utils/helper";
import { FormLoader, useFormLoader } from "../../common_modules/loader"
import Permission from "../../security/permission";
import { AUTH_CODE } from "../../security/authCodes";
import { RiEdit2Line } from "react-icons/ri";
// import useSubmitPrevent from "../../utils/SubmitPrevent";
import usePreventMultiClick from "../../utils/SubmitPrevent";
import { SearchIcon } from "../../common_modules/commonIcons";

const AdPlacementList = () => {
    const [adList, setAdList] = useState();
    const [paginationData, setPaginationData] = useState({});
    const [searchConfig, setSearchConfig] = useState({});
    const [generateScript, setGenerateScript] = useState("");
    const [publisherName, setPublisherName] = useState("");
    // Preevnt Multiple Clicks
    const { btnClicked, setBtnClicked } = usePreventMultiClick();

    const { id: accId, guid: accGuid } = useParams();
    // const accId = location?.id;
    // const accGuid = location?.guid;
    // custom hook
    const { isLoading, startLoading, stopLoading } = useFormLoader(); 

    // multiple submit prevent
    // const submittingRef = useSubmitPrevent();

    // const tableFields = [
    //     { label: "ID", value: "accId", enableSorting: true },
    //     { label: "Name", value: "name", enableSorting: true },
    // ];

    const tableFields = [
        { label: "ID", value: "id", enableSorting: true },
        { label: "Guid", value: "guid", enableSorting: true },
        { label: "Identifier Type", value: "generationType", enableSorting: false },
        { label: "Div ID/Class", value: "generationDivId", enableSorting: false }, // or generationDivClass (handled in UI)
        { label: "Ad Size", value: "slot", enableSorting: false },
        { label: "Tag Type", value: "tagType", enableSorting: false },
        { label: "Powered By", value: "poweredByType", enableSorting: false },
        { label: "Format Type", value: "interscrollerFeature", enableSorting: false },
        { label: "Status", value: "status", enableSorting: false },
        { label: "Remarks", value: "remarks", enableSorting: true },
        { label: "Priority", value: "priority", enableSorting: false },
        { label: "Approval Status", value: "approvalStatus", enableSorting: false },
    ];
    const showAdList = async (search, page, field = "", order = "") => {
        startLoading();
        try {
            const size = 10;
            const res = await API.get(`publisher/adplacement/list/${accId}?search=${search}&page=${page}&size=${size}&field=${field}&order=${order}`);

            // const data = res?.data
            // console.log(data);
            // // const pagination = res?.data?.data;
            // if(data) {
            //     setAdList(data?.content);
            //     setPaginationData(data);
            //     console.log(data);                      
            // }

            const data = res?.data?.data?.content;
            setPublisherName(res?.data?.name);

            if (res.status === 200 && data) {
                setAdList(data);
                // save pagination information
                let pagination = res.data.data;
                delete pagination.content; //  remove data
                setPaginationData(pagination);
            } else {
                setAdList([]);
                setPaginationData({});
            }

        } catch (error) {
            console.error("soemthing went wrong");
        } finally {
            stopLoading();
        }
    }

    const scriptType = adList ? adList[0]?.scriptGenType : '';

    const nextPage = (nextPage) => {
        showAdList("", nextPage, searchConfig?.orderField, searchConfig?.orderDir)
    }


    const onChangeSearch = (params) => {
        setSearchConfig(params)
        showAdList(params.keyword, 0, params.orderField, params.orderDir); // API call
    }

    // Enable Ad 
    // const adStatus = async (id, status) => {
    //     debugger;
    //         if (btnClicked) return;
    //         setBtnClicked(true);
    //         startLoading();
    //     try {
    //         let res;
    //         if (status === 1) {
    //             res = await API.put(`publisher/adplacement/update/status/${id}/5`);
    //             if (res?.data?.status === "Success") {
    //                 alert(res?.data?.message);
    //             } else {
    //                 alert(res?.data?.message);
    //             }
    //         } else {
    //             res = await API.put(`publisher/adplacement/update/status/${id}/1`);
    //             if (res?.data?.status === "Success") {
    //                 alert(res?.data?.message);
    //             } else {
    //                 alert(res?.data?.message);
    //             } 
    //         }
    //         if (res?.data?.status === "Success") {
    //             await showAdList("", 0)
    //         } else {
    //             alert(res?.data?.message);
    //         }
    //     } catch (error) { console.log(error) } 
    //     finally {
    //         setBtnClicked(false);
    //         stopLoading();
    //     } 
    // }

    const adStatus = async (id, status) => {
        if (btnClicked) return;

        setBtnClicked(true);
        startLoading();
        try {
            const newStatus = status === 1 ? 5 : 1;

            const res = await API.put(
                `publisher/adplacement/update/status/${id}/${newStatus}`
            );

            alert(res?.data?.message);

            if (res?.data?.status === "Success") {
                await showAdList("", 0);
            }

        } catch (error) {
            console.log(error);
            alert(error?.response?.data?.message || "Something went wrong");
        } finally {
            setBtnClicked(false);
            stopLoading();
        }
    };

    // Duplicate Ad
    const duplicateAd = async (id) => {
        // if(submittingRef.current) return;
        // submittingRef.current = true;
        if(btnClicked) return;
        setBtnClicked(true);
        startLoading();
        try {
            const res = await API.put(`publisher/adplacement/clone/${id}`);
            if (res?.data?.status === "Success") {
                alert("Ad duplicated successfully")
               await showAdList("", 0)
            }
        } catch (error) {
            console.error(error);
        } finally {
            // submittingRef.current = false;
            setBtnClicked(false);
            stopLoading();
        }
    }

    // Generation type
    const generationType = async (type) => {
        if(btnClicked) return;
        setBtnClicked(true);
        startLoading();
        try {
            const res = await API.get(`/publisher/adplacement/generate/tag/${accGuid}/${type}`);
            setGenerateScript(res?.data?.data);

        } catch (error) {
            setGenerateScript("Failed to generate tag");
            console.log(error);
        } finally {
            setBtnClicked(false);
            stopLoading();
        }
    }

    useEffect(() => {
        if (accGuid) {
            showAdList("", 0);
        }
    }, [accGuid])

    return (
        <FormLoader isLoading={isLoading} text={"Loading..."}>
            <div className="breadCrumb gradient-bg">
                <Link to={'/dashboard'}><span>Home</span></Link>
                <Permission code={AUTH_CODE.accounts.publisherListing}>
                    <Link to={'/active-publisher'}><span>Publisher</span></Link>
                </Permission>
                 {/* <span>{publisherName}</span> */}
                 <Link to={`/publisher/info/${accId}/${accGuid}`}><span>{publisherName}</span></Link>
                <span>Manage Adplacement</span>
                {/* <span>{accId}</span> */}
            </div>
            {
                generateScript && (
                    <Card className="mb-3">
                        <div className="generateTag">
                            <pre>{generateScript}</pre>
                        </div>
                    </Card>
                )}
            <Card>
                <h6 className="title mb-3 mt-3 ms-3">Ad Placement List</h6>
                <div className="row filter">
                    <div className="activePubAllBtns" style={{ display: "flex", width: "max-content" }}>
                        <Permission code={AUTH_CODE.adPlacement.createAdPlacement}>
                            <Link to={`/publisher/adplacement/${accId}/${accGuid}`} state={{ publisherName: publisherName }} style={{ color: '#ffffff', textDecoration: 'none' }} >
                                <button>Create Ad Placement <LuPlus /></button>
                            </Link>
                        </Permission>
                        {adList?.length > 0 && (
                            
                                <Permission code={AUTH_CODE.adPlacement.generateAmpTags}>
                                 {[0, 1, 2, 3, 4, 5].includes(scriptType) ? (
                                    <>
                                        {
                                            [0, 4].includes(scriptType) && (
                                                <button disabled={btnClicked} onClick={() => generationType(0)}>Generate JSON <LuSquareArrowOutUpRight /></button>
                                            )
                                        }
                                        {
                                            [1, 5].includes(scriptType) && (
                                                <button disabled={btnClicked} onClick={() => generationType(1)}>Generate Bundle JS <LuSquareArrowOutUpRight /></button>
                                            )
                                        }
                                        {
                                            [2, 4].includes(scriptType) && (
                                                <button disabled={btnClicked} onClick={() => generationType(2)}>Generate AMP JS <LuCircleArrowOutUpRight /></button>
                                            )
                                        }
                                        {
                                            [3, 5].includes(scriptType) && (
                                                <button disabled={btnClicked} onClick={() => generationType(3)}>Generate AMP Bundle JS <LuCircleArrowOutUpRight /></button>
                                            )
                                        }
                                    </>
                                    ) : (
                                        <button type="button" onClick={() => alert("Please create GAM Setting first")}>
                                            Generate Bundle Js
                                        </button>
                                    )
                                }
                                <Link to={`/publisher/adplacement/amp/${accId}/${accGuid}`}><button>Amp tags < LuZap /></button></Link>
                                </Permission>
                        )}
                    </div>
                    <FilterBar fields={tableFields} onSearch={onChangeSearch} />
                </div>
                <div className="mt-0 table-wrapper mt-3">
                    <Table striped bordered responsive hover size="sm" className="custom-table align-middle">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Guid <SearchIcon className="ms-1" size={10} fill="white" /></th>
                                <th>Identifier Type</th>
                                <th>Div ID/Class <SearchIcon className="ms-1" size={10} fill="white" /></th>
                                <th>Ad Size <SearchIcon className="ms-1" size={10} fill="white" /></th>
                                <th>Tag Type <SearchIcon className="ms-1" size={10} fill="white" /></th>
                                <th>Device Type <SearchIcon className="ms-1" size={10} fill="white" /></th>
                                <th>Powered By <SearchIcon className="ms-1" size={10} fill="white" /></th>
                                <th>Format Type <SearchIcon className="ms-1" size={10} fill="white" /></th>
                                <th>Status</th>
                                <th>Remarks <SearchIcon className="ms-1" size={10} fill="white" /></th>
                                <th>Priority</th>
                                <th>Approval Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                adList?.length > 0 ?
                                    adList?.map((list, index) => (
                                        <tr className={list?.approvalStatus !== 1 ? "approvalPending" : ""}>
                                            <td>{list?.id}</td>
                                            <td>{list?.guid}</td>
                                            <td>{list?.generationType === 1 ? "ID" : "Class"}</td>
                                            <td>{list?.generationType === 1 ? list?.generationDivId : list?.generationDivClass}</td>
                                            <td>{list?.slot}</td>
                                            <td>{list?.tagType}</td>
                                            <td>{list?.deviceType}</td>
                                            <td>{list?.poweredByType}</td>
                                            <td>{list?.interscrollerFeature === "" ? "Banner" : list?.interscrollerFeature}</td>
                                            <td style={{ textAlign: "center" }}>
                                                <span className={`badge ${list?.status === 1 ? "active" : "warning"}`}>
                                                    {list?.status === 1 ? "Active" : "Pending"}
                                                </span>
                                            </td>
                                            <td>{list?.remarks}</td>
                                            <td>{list?.priority}</td>
                                            <td>{list?.approvalStatus === 1 ? "Active" : "Pending"}</td>
                                            <td className="activePubAllBtns">

                                                <Permission code={AUTH_CODE.adPlacement.activateDeactivateAdPlacement}>
                                                    <button disabled={btnClicked} onClick={() => adStatus(list?.id, list?.status)}>
                                                        {list.status === 1 ? (
                                                            <>
                                                                Disable <LuDiameter />
                                                            </>
                                                        ) : (
                                                            <>
                                                                Enable <LuCircleCheckBig />
                                                            </>
                                                        )}
                                                    </button>
                                                </Permission>

                                                <Permission code={AUTH_CODE.adPlacement.editUpdateAdPlacement}>
                                                    <Link to={`/publisher/edit/adplacement/${accId}/${accGuid}/${list?.id}`} state={{ publisherName: publisherName }} style={{ color: '#ffffff', textDecoration: 'none' }}>
                                                        <button> Edit <LuPencilLine /> </button>
                                                    </Link>
                                                </Permission>

                                                <Permission code={AUTH_CODE.adPlacement.makeDuplicateAdPlacement}>
                                                    <button disabled={btnClicked} onClick={() => duplicateAd(list?.id)}>
                                                        Make Duplicate <LuFiles /></button>
                                                </Permission>
                                            </td>
                                        </tr>
                                    )) : <tr>
                                        <td colSpan="14" style={{ textAlign: "center" }}>
                                            No Data Found
                                        </td>
                                    </tr>
                            }
                        </tbody>
                    </Table>
                </div>
            </Card>
            {/* pegination */}
            <Pagination
                jumpPage={true}
                initCall={false}
                count={true}
                component={AdPlacementList.name}
                size={"sm"}
                paginationData={paginationData}
                nextPage={nextPage} />
        </FormLoader>
    )
}

export default AdPlacementList;